<template>


    <!-- 导航栏 -->
    <van-nav-bar :title=data.title @click-left="onClickLeft" >
       
          <template #left>
              <van-icon name="arrow-left" /> 返回
          </template>
      </van-nav-bar>

      <van-image
      width="100%"
      height="100%"
      :src="data.src"
     />


</template>      

<script setup>
import { Image as VanImage } from 'vant';
import { onMounted, ref } from 'vue'
import { useopenidStore } from '@/stores'
import router from '@/router'
var data = ref({
    title: '医院简介',
    src:'./image/logo.jpg',
    lx:1
})


onMounted(() => {
  data.value.openid = useopenidStore().openid
  data.value.lx = router.currentRoute.value.query.lx
  console.log('lx'+data.value.lx)

  if (data.value.lx==1){
    data.value.title='医院简介'
    data.value.src='./image/yyjj.jpg'
  }

  if (data.value.lx==2){
    data.value.title='科室介绍'
    data.value.src='./image/ksjs.jpg'
  }

  if (data.value.lx==3){
    data.value.title='名医简介'
    data.value.src='./image/myjj.jpg'
  }
  if (data.value.lx==4){
    data.value.title='健康宣教'
    data.value.src='./image/jkxj.jpg'
  }

  if (data.value.lx==5){
    data.value.title='楼层分布'
    data.value.src='./image/lcfb.jpg'
  }
  if (data.value.lx==6){
    data.value.title='用户指南'
    data.value.src='./image/yhzn.jpg'
  }

}
)

    const onClickLeft = () => history.back();
</script>

<style scoped lang="less">
.van-nav-bar {
  background: #1989fa;

  /deep/ .van-nav-bar__title {
    color: white;
  }

  /deep/ .van-icon {
    color: white;
  }

  /deep/ .van-nav-bar__right {
    color: white;
  }

  /deep/ .van-nav-bar__left {
    color: white;
  }
}

.byxx {
  background-color: #888;
}

.office {
  width: 100%;
}

.parter {
  margin-top: 1em;
}
</style>